var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('img',{staticStyle:{"max-width":"100%"},attrs:{"src":_vm.thumbSrc,"alt":"image"}})}
var staticRenderFns = []

export { render, staticRenderFns }